module.exports = __webpack_public_path__ + "static/media/powerLogo1.b6a15281.png";